import React, { Component } from "react";
import MainMenu from "../components/mainMenu";
import SubNavigation from "../components/subNavigation";
import TopBanner from "../components/topBanner";
import AnimatedBackground from "../components/animatedBackground";
import InstagramFeed from "../components/instagramFeed";
import Footer from "../components/footer";
import SuitMaterial from "../components/suitMaterial";
import WarmUpSuit from "../components/warmUpSuit";

import ImageCarousel from "../components/imageCarousel";

export default class SuitBobsleigh extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.title = "QwixSkinz || Bobsled Race Suits";
  }
  componentWillUnmount() {}

  render() {
    return (
      <React.Fragment>
        <MainMenu />
        {/* <TopBanner
					bannerHeight="full"
					title="Bobsleigh Suit"
					images={[
						"bobsleigh/team-canada-bobsled-race-suits.jpg",
						"bobsleigh/aussie-national-bobsleigh-team.jpg",
						"bobsleigh/canada-olympic-team-bobsligh-race-suit.jpg"
					]}
				/> */}
        <SubNavigation
          location={this.props.location}
          refs={this.refs}
          navItems={[
            { title: "Suit Overview", id: "overview" },
            { title: "Warm Up Suit", id: "warmupsuit" },
            { title: "Material", id: "material" },
            { title: "Protective Shirt", id: "protective-shirt" },
          ]}
        />
        {/* Bobsled Suit Overview */}
        <div className="qs-b" ref="overview">
          <div className="container block-wrap behind-trees">
            <div className="d-flex flex-row flex-wrap align-items-stretch">
              <div className="col-12 content dark pb-0">
                <div className="section-title">
                  <h1 className="title">Bobsleigh Race Suits</h1>
                </div>
              </div>
              <div className="col-12 col-md-6 content dark pt-0">
                <p className="lead">
                  Qwixskinz Bobsleigh Race Suits are worn by every level of
                  Bobsleigh team from development to World Cup Champions.
                </p>
                <p>
                  The Qwixskinz Bobsleigh Race Suit is the perfect balance of
                  fit &amp; function. Using only high quality 4-way stretch
                  fabrics carefully selected to also add compression benefits
                  that are optimal in the explosive push start.
                </p>
                <p>An option of Hood or Collar available.</p>
                <p>
                  Our original graphics/artwork can be customized for your team
                  &amp; sponsor logos can be integrated into the artwork. Any
                  customization charges will be quoted at the time of order.
                </p>
              </div>
              <div className="col-12 col-md-6">
                <div className="">
                  <ImageCarousel
                    images={[
                      "/images/suits/bobsled/IMG_3003.jpg",
                      "/images/suits/bobsled/IMG_2985.jpg",
                      "/images/suits/bobsled/IMG_2989.jpg",
                      "/images/suits/bobsled/IMG_3006.jpg",
                      "/images/suits/bobsled/IMG_3010.jpg",
                      "/images/suits/bobsled/IMG_3013.jpg",
                      "/images/suits/bobsled/IMG_3016.jpg",
                      "/images/suits/bobsled/IMG_3019.jpg",
                      "/images/suits/bobsled/IMG_3026.jpg",
                      "/images/suits/bobsled/IMG_3029.jpg",
                      "/images/suits/bobsled/IMG_3032.jpg",
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Warm Up Suit Section */}
        <WarmUpSuit ref="warmupsuit" />
        {/* Suit Material Section */}

        <div className="qs-b" ref="material">
          <div className="container block-wrap behind-mnt1">
            <div className="d-flex flex-row flex-wrap align-items-stretch">
              <div className="col-12 content dark pb-0">
                <div className="section-title">
                  <h1 className="title">Suit Material</h1>
                </div>
              </div>
              <div className="col-12 content dark pt-0">
                <p className="lead">
                  Our 4-Way stretch fabric allows for a full range of motion
                  with no limitations to your movements.
                </p>
                <p>
                  The fabric is fleece backed for warmth &amp; a fabric surface
                  treatment helps dirt &amp; moisture resistance. The perfect
                  weight for outdoor warm ups.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="qs-b" ref="protective-shirt">
          <div className="container block-wrap behind-mnt1">
            <div className="d-flex flex-row flex-wrap align-items-stretch">
              <div className="col-12 content dark pb-0">
                <div className="section-title">
                  <h1 className="title">Bobsleigh Protective Shirt</h1>
                </div>
              </div>
              <div className="col-12 col-md-6 content dark pt-0">
                <ul>
                  <li>Extreme Abrasion Protection</li>
                  <li>
                    Considered the BEST in Bobsleigh Protective wear, our
                    Protective Shirts are worn by the top Bobsledders in the
                    World including World, World Cup &amp; Olympic Champions
                  </li>
                  <li>
                    Kevlar panels with a moisture wicking shirt body for comfort
                    and fit
                  </li>
                  <li>
                    Protects Upper Chest/Shoulders/Arms &amp; Back in the event
                    of a Bobsleigh crash
                  </li>
                  <li>Unisex Sizes Small, Medium, Large, X-Large, XX-Large</li>
                </ul>
              </div>
              <div className="col-12 col-md-6">
                <div className="">
                  <img src="/images/suits/bobsled/qwixskinz-bobsleigh-protective-shirt.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <InstagramFeed />
        <Footer />
        <AnimatedBackground />
      </React.Fragment>
    );
  }
}
